import axiosInstance from "../config/axiosInstance";
import { API_ENDPOINTS } from "../config/api";

export const getPayloadData = (parserConfigId: number) =>
  axiosInstance.get(API_ENDPOINTS.getPayloadData(parserConfigId));

export const parsePayload = (payload: any) =>
  axiosInstance.post(API_ENDPOINTS.parsePayload, payload);

export const parsePayloadWithValue = (payload: any) =>
  axiosInstance.post(API_ENDPOINTS.parsePayloadWithValue, payload);

export const extractJsonSchema = (payload: any) =>
  axiosInstance.post(API_ENDPOINTS.extractJsonSchema, payload);

export const extractJsonSchemaWithValue = (payload: any) =>
  axiosInstance.post(API_ENDPOINTS.extractJsonSchemaWithValue, payload);

export const createPayloadData = (payload: any) =>
  axiosInstance.post(API_ENDPOINTS.createPayloadData, payload);

export const createKeyValueTable = (payload: any) =>
  axiosInstance.post(API_ENDPOINTS.createKeyValueTable, payload);

export const updatePayloadData = (payload: any) =>
  axiosInstance.put(API_ENDPOINTS.updatePayloadData, payload);

export const updateKeyValueTable = (payload: any) =>
  axiosInstance.put(API_ENDPOINTS.updateKeyValueTable, payload);

export const getKeyValueTablesRaw = (parserConfigId: number) =>
  axiosInstance.get(API_ENDPOINTS.getKeyValueTablesRaw(parserConfigId));

export const getGroupTablesByKeyValueIds = (ids: number[]) =>
  axiosInstance.get(API_ENDPOINTS.getGroupTablesByKeyValueIds(ids));
